<template>
  <div v-if="tiles.length" class="admin-start-hub__row">
    <h3 v-if="title" class="admin-start-hub__row-title">{{ title }}</h3>
    <div class="admin-start-hub__tile-grid">
      <a
        v-for="tile in tiles"
        :key="tile.key"
        class="admin-start-hub__tile"
        :href="tile.href"
      >
        <span class="admin-start-hub__tile-icon" aria-hidden="true">
          <i class="fa" :class="tile.icon"></i>
        </span>
        <span class="admin-start-hub__tile-label">{{ tile.label }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StartHubTileRow',
  props: {
    title: { type: String, default: '' },
    tiles: { type: Array, default: () => [] },
  },
};
</script>
